import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_filter",
  "use": "icon-project_filter-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_filter\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M24.896 3H3.103a1 1 0 00-.883 1.468l7.167 13.538c.019.035.039.068.06.1l.236.342-.075.408L8.469 25h10.999l-.938-6.308s0 0 0 0l-.125-.4.197-.37 7.176-13.451A1 1 0 0024.896 3z\" /><path stroke-linecap=\"square\" d=\"M11 19h7M7 11h15\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol